/* eslint-disable */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://lexback-production.up.railway.app';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    try {
      await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } catch {
      setError('Erreur réseau. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#F5F3EE', padding:'2rem' }}>
      <div style={{ background:'#fff', border:'0.5px solid rgba(0,0,0,0.07)', borderRadius:'14px', padding:'2.5rem', width:'100%', maxWidth:'420px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'20px', fontWeight:700, color:'#B8860B', marginBottom:'4px' }}>Lexback</div>

        {sent ? (
          <div>
            <div style={{ fontFamily:'Syne, sans-serif', fontSize:'16px', fontWeight:600, color:'#1A1916', marginBottom:'12px' }}>Email envoyé ✓</div>
            <div style={{ fontSize:'13px', color:'rgba(26,25,22,0.55)', lineHeight:1.6, marginBottom:'24px' }}>
              Si un compte existe avec l'adresse <strong>{email}</strong>, vous recevrez un lien de réinitialisation dans quelques minutes.
              <br /><br />
              Vérifiez aussi vos spams.
            </div>
            <Link to="/login" style={{ textDecoration:'none' }}>
              <button style={{ width:'100%', background:'#1A1916', color:'#fff', border:'none', padding:'10px', borderRadius:'8px', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>
                Retour à la connexion
              </button>
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ fontFamily:'Syne, sans-serif', fontSize:'16px', fontWeight:600, color:'#1A1916', marginBottom:'6px' }}>Mot de passe oublié ?</div>
            <div style={{ fontSize:'13px', color:'rgba(26,25,22,0.45)', marginBottom:'24px', lineHeight:1.5 }}>
              Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </div>

            {error && (
              <div style={{ background:'rgba(176,48,32,0.08)', border:'0.5px solid rgba(176,48,32,0.2)', borderRadius:'7px', padding:'10px 12px', fontSize:'12px', color:'#B03020', marginBottom:'16px' }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom:'16px' }}>
              <div style={{ fontSize:'10px', textTransform:'uppercase', letterSpacing:'0.07em', color:'rgba(26,25,22,0.35)', marginBottom:'6px' }}>Adresse email</div>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="votre@email.com" required autoFocus
                style={{ width:'100%', padding:'10px 12px', background:'#F0EDE5', border:'0.5px solid rgba(0,0,0,0.1)', borderRadius:'8px', fontSize:'13px', color:'#1A1916', outline:'none', fontFamily:'DM Sans, sans-serif', boxSizing:'border-box' }}
              />
            </div>

            <button type="submit" disabled={loading||!email} style={{ width:'100%', background:'#B8860B', color:'#fff', border:'none', padding:'10px', borderRadius:'8px', fontSize:'13px', fontWeight:500, cursor:loading||!email?'not-allowed':'pointer', opacity:loading||!email?0.7:1, fontFamily:'DM Sans, sans-serif' }}>
              {loading ? 'Envoi…' : 'Envoyer le lien →'}
            </button>

            <div style={{ textAlign:'center', marginTop:'16px', fontSize:'12px', color:'rgba(26,25,22,0.4)' }}>
              <Link to="/login" style={{ color:'#B8860B', textDecoration:'none' }}>← Retour à la connexion</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
